import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-modal-unlock',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './generic-modal-unlock.component.html',
  styleUrls: ['./generic-modal-unlock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericModalUnlockComponent {}
